var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default",[_c('v-btn',{staticClass:"mx-1",attrs:{"light":"","loading":_vm.loading},on:{"click":_vm.exportServiceRecords}},[_vm._v(" EXPORT ")])],{"loading":_vm.loading,"on":{ click: _vm.exportServiceRecords }})],2)}
var staticRenderFns = []

export { render, staticRenderFns }